export default "__VITE_ASSET__DEUBj77I__"